import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconDisconnectProps } from './IconDisconnect.types'
import * as Styled from './styles/IconDisconnect.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDisconnect: FC<IconDisconnectProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDisconnectProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconDisconnectProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='m14.102 16.2-2.836 2.94a4.427 4.427 0 0 1-6.235.329l-.125-.117a4.428 4.428 0 0 1-.332-6.239L6.5 10.965a4.431 4.431 0 0 1 6.238-.328l.125.117c.453.41.817.906 1.067 1.465'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M12.66 4.945a4.431 4.431 0 0 1 6.238-.328l.125.117a4.431 4.431 0 0 1 .329 6.239l-1.93 2.144a4.432 4.432 0 0 1-6.238.328M7.883 3.582l1.344 1.535M8.379 6.48 6.28 6.34m4.408-1.883.14-2.098'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconDisconnect
